import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Medal } from 'lucide-react';

const SecuritySection = () => {
  return (
    <section className="py-20 bg-[#f8faff]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl lg:text-4xl font-bold text-center mb-4"
        >
          You are in Good Hands
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 max-w-4xl mx-auto">
          {/* Security Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm"
          >
            <h3 className="text-lg font-semibold text-gray-900 mb-6">
              Robust security for your data's protection
            </h3>
            <div className="flex items-center gap-6">
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362cec851558e8d2e47950_image%206718.webp"
                alt="ISO Certification"
                className="h-16 object-contain"
              />
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362cebaa6fb79a9289a746_image%206715.webp"
                alt="SOC2 Certification"
                className="h-16 object-contain"
              />
            </div>
          </motion.div>

          {/* Awards Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm"
          >
            <h3 className="text-lg font-semibold text-gray-900 mb-6">
              Market Leaders across 15+ Categories
            </h3>
            <div className="flex items-center gap-6">
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362cec515cf7336093fbb1_users-love-us%201.webp"
                alt="Users Love Us"
                className="h-16 object-contain"
              />
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362ceb25c1875da93e14f8_medal%201.webp"
                alt="G2 Badge"
                className="h-16 object-contain"
              />
              <img
                src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/65362cebb6791881debeba3b_medal%20(2)%201.webp"
                alt="G2 Badge 2"
                className="h-16 object-contain"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
